import { z } from "zod";

export const CouponSchema = z.object({
  name: z.string().nullish(),
  amountOff: z.number().nullish(),
  percentOff: z.number().nullish(),
});

export type CouponType = z.infer<typeof CouponSchema>;
